import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from '../../components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { RedeEspecialAcordoDialogBase } from '../rede-especial-dialog-base';
import { TipoAtualizacaoEnum } from '../rede-especial-enuns';
import { AcordoRedeEspecialViewModel } from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-recusar-acordo-dialog',
  templateUrl: './recusar-acordo-dialog.component.html',
  styleUrls: ['./recusar-acordo-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSpinnerOverlayComponent,
  ],
})
export class RecusarAcordoDialogComponent extends RedeEspecialAcordoDialogBase<RecusarAcordoDialogComponent> {
  formRejeicao: FormGroup;

  constructor(
    private fb: FormBuilder,
    dialogRef: MatDialogRef<RecusarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) acordosSelecionados: AcordoRedeEspecialViewModel[],
    service: RedeEspecialService,
    snackBar: SnackBarService,
  ) {
    super(dialogRef, acordosSelecionados ?? [], service, snackBar);
    this.formRejeicao = this.fb.group({ motivo: ['', Validators.required] });
  }

  onConfirmar(): void {
    this.loading = true;
    const payload = {
      listaAcordos: this.mapAcordosParaLista(),
      dscUsuario: this.usuarioLogin,
      tipoAtualizacao: TipoAtualizacaoEnum.REJEICAO,
    };
    this.service.aprovarOuRejeitarAcordos(payload).subscribe({
      next: () => {
        this.snackBar.flashMessage(
          'Acordo(s) recusado(s) com sucesso!',
          ['snackbar-success'],
          'Fechar',
          2,
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackBar.flashMessage(
          'Erro ao recusar acordo(s)!',
          ['snackbar-error'],
          'Fechar',
          2,
        );
      },
      complete: () => (this.loading = false),
    });
  }
}
